import { type MCPServerInfo } from '../../types';

const GenaiToolboxPostgresServer: MCPServerInfo = {
  serverId: 'GENAI_TOOLBOX_POSTGRES',
  name: 'MCP Toolbox for PostgreSQL',
  slug: 'genai-toolbox-postgres',
  description:
    "Google's MCP Toolbox for Databases — PostgreSQL prebuilt. Connect to your PostgreSQL database using the Model Context Protocol.",
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/googleapis/genai-toolbox',
    commitSha: 'latest',
    packageType: 'docker',
    packageName: 'ghcr.io/googleapis/genai-toolbox'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [
      'postgresHost',
      'postgresUser',
      'postgresPassword',
      'postgresDatabase'
    ],
    properties: {
      postgresHost: {
        type: 'string',
        description: 'PostgreSQL host (e.g. localhost or db.example.com)',
        sensitive: false
      },
      postgresPort: {
        type: 'string',
        description: 'PostgreSQL port (default: 5432)',
        sensitive: false
      },
      postgresUser: {
        type: 'string',
        description: 'PostgreSQL username',
        sensitive: false
      },
      postgresPassword: {
        type: 'string',
        description: 'PostgreSQL password',
        sensitive: true
      },
      postgresDatabase: {
        type: 'string',
        description: 'PostgreSQL database name',
        sensitive: false
      }
    }
  }
};

export default GenaiToolboxPostgresServer;
